import Util from './../../../libs/util'
const { ajax,globalModalContain } = Util
function http({ url,type,params,fail,final }) {
    return new Promise((resolve,reject) => {
        ajax[type](url,params).then(
            res => {
                const { code, data,msg = '' } = res.data || {}
                if (code === 1) {
                    resolve(data)
                } else {
                    globalModalContain.$Modal.error({
                        title:'错误',
                        content: msg
                    })
                    reject(new Error(''))
                }
            }
        ).catch(() => {
            globalModalContain.$Modal.error({
                title:'错误',
                content: '网络错误'
            })
            if (fail) {
                fail()
            }
            reject(new Error('网络错误'))
        }).finally(() => {
            if (final) {
                final()
            }
        })
    })
}


// 获取app列表
export function getProjectListApi(params,callBack) {
    return http({
        url: '/bank_balance_history/tree_info',
        type:'get',
        final:callBack,
        params: { params }
    })
}

// 获取每一个银行的详情 
export function getProjectItemTableApi(params,callBack) {
    return http({
        url: '/bank_balance_history/list',
        type:'get',
        final:callBack,
        params:{ params }
    })
}


// 修改月初基金理财的其实余额

export function setBalanceNumberApi(params,callBack) {
    return http({
        url: '/bank_balance_setting/update',
        type:'post',
        final:callBack,
        params
    })
}


// 获取分红数据

export function getRecordsListApi(params,callBack) {
    return http({
        url: '/dividend_record/list',
        type:'get',
        final:callBack,
        params: { params }
    })
}

// 新增分红记录
export function createRecordItemApi(params,callBack) {
    return http({
        url: `/dividend_record/${params.id ? 'update' : 'create'}`,
        type:'post',
        final:callBack,
        params
    })
}

// 删除分红记录

export function deleteRecordItemApi(params,callBack) {

    return http({
        url: `/dividend_record/delete`,
        type:'post',
        final:callBack,
        params
    })
}

// 余额

export function getBankbalanceSettingApi(params,callBack) {
    return http({
        url: `/bank_balance_setting/list`,
        type:'get',
        final:callBack,
        params:{ params }
    })
}